import {
    fetchClinicsURL,
    insertOurUpdateClinicURL,
    insertOrUpdateNavigatorUrl,
} from "../../apiEndPoints"
import { axiosGet, axiosPost } from "../../utilities/axiosRequest"
import { logTransaction } from "../appActions"
import {
    fetchClinicsFailure,
    fetchClinicsRequest,
    fetchClinicsSuccess,
    updateSelectedClinic,
} from "./clinicSlice"

export const fetchClinic = (clinicId, success, failure) => {
    let url = fetchClinicsURL

    return dispatch => {
        axiosPost(url, {
            clinicId: clinicId,
        })
            .then(response => {
                const clinics = response.data.responseData || []
                success && success(clinics)
            })
            .catch(err => {
                failure && failure([])
            })
    }
}

export const fetchClinics = (
    user,
    orgId,
    success,
    failure,
    pageNo = 0,
    pageSize = 100,
    clinicName = ""
) => {
    let organisation =
        !orgId || orgId === undefined || orgId === ""
            ? user?.organizationlistforuser?.[0]?.organizationId
            : orgId
    var dataSource = {
        source: "PORTAL",
        organizationId: organisation,
    }

    let url = fetchClinicsURL
    url += `?pageNo=${pageNo}&pageSize=${pageSize}`
    if (clinicName) {
        url += `&clinicName=${clinicName}`
    }

    return dispatch => {
        dispatch(fetchClinicsRequest())
        console.log("fetch clinic url", fetchClinicsURL, dataSource)
        axiosPost(url, dataSource)
            .then(response => {
                const clinics = response.data.responseData || []
                const activeClinics = clinics.filter(clinic => clinic.isActive)

                const savedClinicId =
                    typeof window !== "undefined"
                        ? localStorage.getItem("lastSelectedClinicId")
                        : null
                const savedClinic = savedClinicId
                    ? activeClinics.find(
                          c => String(c.clinicId) === savedClinicId
                      )
                    : null

                if (savedClinic) {
                    dispatch(updateSelectedClinic({ ...savedClinic }))
                } else if (clinics.length === 1) {
                    dispatch(updateSelectedClinic({ ...clinics?.[0] }))
                }

                success && success(clinics)
                dispatch(logTransaction("Fetch Clinics", response))
                dispatch(
                    fetchClinicsSuccess(activeClinics)
                )
            })
            .catch(err => {
                failure && failure([])
                dispatch(logTransaction("Fetch Clinics failure", err))
                dispatch(fetchClinicsFailure(err.message))
            })
    }
}

// Fetches every clinic of an organization (all pages) without touching the
// redux clinic list / selected clinic, unlike fetchClinics above.
export const fetchAllOrganizationClinics = (orgId, success, failure) => {
    const pageSize = 100
    return async dispatch => {
        try {
            let allClinics = []
            for (let pageNo = 0; ; pageNo++) {
                const response = await axiosPost(
                    `${fetchClinicsURL}?pageNo=${pageNo}&pageSize=${pageSize}`,
                    { source: "PORTAL", organizationId: orgId }
                )
                const clinics = response.data.responseData || []
                allClinics = allClinics.concat(clinics)
                if (clinics.length < pageSize) break
            }
            success && success(allClinics)
        } catch (err) {
            dispatch(logTransaction("Fetch all organization clinics failure", err))
            failure && failure([])
        }
    }
}

export const fetchClinicsCount = (
    user,
    orgId,
    success,
    failure,
    clinicName = ""
) => {
    let organisation =
        !orgId || orgId === undefined || orgId === ""
            ? user?.organizationlistforuser?.[0]?.organizationId
            : orgId
    var dataSource = {
        source: "PORTAL",
        organizationId: organisation,
    }

    let url = fetchClinicsURL
    url += `?isCount=${true}`
    if (clinicName) {
        url += `&clinicName=${clinicName}`
    }

    return dispatch => {
        console.log("fetch clinic url", fetchClinicsURL, dataSource)
        axiosPost(url, dataSource)
            .then(response => {
                const clinics = response.data.responseData || 0
                success && success(clinics)
                dispatch(logTransaction("Fetch Clinics count", response))
            })
            .catch(err => {
                failure && failure([])
                dispatch(logTransaction("Fetch Clinics failure count", err))
            })
    }
}

export const insertOrUpdateClinic = (data, success, failure) => {
    return function (dispatch, getState) {
        let url = insertOurUpdateClinicURL
        axiosPost(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD == 200) {
                    // let data = response.data.responseData;
                    success(response.data.responseData)
                } else {
                    failure(response.data?.statusMSG)
                }
            })
            .catch(err => {
                failure("Failed to update the clinic!")
            })
    }
}

export const insertOrUpdateNavigator = (data, success, failure) => {
    return function (dispatch, getState) {
        let url = insertOrUpdateNavigatorUrl
        axiosPost(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD == 200) {
                    // let data = response.data.responseData;
                    success(response.data.responseData)
                } else {
                    failure(response.data?.statusMSG)
                }
            })
            .catch(err => {
                failure("Failed to update!")
            })
    }
}

export const fetchWebsiteConfigDetails = (data, success, failure) => {
    return function (dispatch, getState) {
        let url = `getWebSiteDetails?clinicDomainName=${data}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    // let data = response.data.responseData;
                    success(response?.data?.responseData)
                } else {
                    failure(response?.data?.statusMSG)
                }
            })
            .catch(e => {
                failure(e)
            })
    }
}
